import { Outlet } from 'react-router-dom';
import { ProtectedRoute } from '../components/ProtectedRoute';

/**
 * Layout for the pending approval page.
 * Requires authentication but not approval.
 */
export default function PendingApprovalLayout() {
  return (
    <ProtectedRoute requireApproval={false}>
      <Outlet />
    </ProtectedRoute>
  );
}
